import { defineStore } from 'pinia'

export default defineStore({
  id: 'cooperatorDataTable',
  state: () => {
    return {
      columnCooperatorState: [],
      columnCooperatorDocumentState: [],
      columnCooperatorCommodityState: [],
      isCooperatorArchive: false,
      isCooperatorBankArchive: false,
      isCooperatorBusinessOpportunityArchive: false,
      isCooperatorCommodityArchive: false,
      isCooperatorContactArchive: false,
      isCooperatorInvoicingInformationArchive: false,
      isCooperatorDocumentArchive: false,
      isCooperatorTaskCompleteTimeArchive: false
    }
  },
  actions: {
    setColumnCooperatorState: function (payload: any) {
      this.columnCooperatorState = payload
    },
    setColumnCooperatorDocumentState: function (payload: any) {
      this.columnCooperatorDocumentState = payload
    },
    setColumnCooperatorCommodityState: function (payload: any) {
      this.columnCooperatorCommodityState = payload
    },
    setIsCooperatorArchive: function (payload: any) {
      this.isCooperatorArchive = payload
    },
    setIsCooperatorBankArchive: function (payload: any) {
      this.isCooperatorBankArchive = payload
    },
    setIsCooperatorBusinessOpportunityArchive: function (payload: any) {
      this.isCooperatorBusinessOpportunityArchive = payload
    },
    setIsCooperatorCommodityArchive: function (payload: any) {
      this.isCooperatorCommodityArchive = payload
    },
    setIsCooperatorContactArchive: function (payload: any) {
      this.isCooperatorContactArchive = payload
    },
    setIsCooperatorInvoicingInformationArchive: function (payload: any) {
      this.isCooperatorInvoicingInformationArchive = payload
    },
    setIsCooperatorDocumentArchive: function (payload: any) {
      this.isCooperatorDocumentArchive = payload
    },
    setIsCooperatorTaskCompleteTimeArchive: function (payload: any) {
      this.isCooperatorTaskCompleteTimeArchive = payload
    }
  },
  getters: {
    getColumnCooperatorState: (state: any) => state.columnCooperatorState,
    getColumnCooperatorDocumentState: (state: any) => state.columnCooperatorDocumentState,
    getColumnCooperatorCommodityState: (state: any) => state.columnCooperatorCommodityState,
    getIsCooperatorArchive: (state: any) => state.isCooperatorArchive,
    getIsCooperatorBankArchive: (state: any) => state.isCooperatorBankArchive,
    getIsCooperatorBusinessOpportunityArchive: (state: any) => state.isCooperatorBusinessOpportunityArchive,
    getIsCooperatorCommodityArchive: (state: any) => state.isCooperatorCommodityArchive,
    getIsCooperatorContactArchive: (state: any) => state.isCooperatorContactArchive,
    getIsCooperatorInvoicingInformationArchive: (state: any) => state.isCooperatorInvoicingInformationArchive,
    getIsCooperatorDocumentArchive: (state: any) => state.isCooperatorDocumentArchive,
    getIsCooperatorTaskCompleteTimeArchive: (state: any) => state.isCooperatorTaskCompleteTimeArchive
  }
})
